import logo from "../assets/logo.png";

export const SITE = {
  name: "Next-G Phone Repair",
  shortName: "Next-G",
  motto: "Next gen service for the Next gen.",
  category: "Phone, laptop & everyday tech repair",
  phoneDisplay: "368 599 2771",
  phoneIntl: "+1 368 599 2771",
  phoneHref: "tel:+13685992771",
  smsHref: "sms:+13685992771",
  email: "nextphones1921@gmail.com",
  emailHref: "mailto:nextphones1921@gmail.com",
  address: "3012 17th Ave SE, Calgary, Alberta",
  addressShort: "3012 17th Ave SE",
  city: "Calgary",
  locationCue: "Next to TD Bank",
  mapsUrl: "https://maps.app.goo.gl/JUPQX3ZC4oAsHuhz9",
  mapsEmbed:
    "https://www.google.com/maps?q=3012%2017th%20Ave%20SE%2C%20Calgary%2C%20AB&output=embed",
  logo,
  hours: [
    { days: "Monday – Saturday", time: "10:00 AM – 8:00 PM" },
    { days: "Sunday", time: "11:00 AM – 6:00 PM" },
  ],
  languages: [
    { code: "EN", label: "Phone repair", ethiopic: false },
    { code: "AM", label: "ሞባይል ምርኣይ", ethiopic: true },
    { code: "TI", label: "ቴለፎን ምርኣይ", ethiopic: true },
  ],
};

export function getOpenStatus(now = new Date()) {
  const day = now.getDay();
  const mins = now.getHours() * 60 + now.getMinutes();
  const open = day === 0 ? 11 * 60 : 10 * 60;
  const close = day === 0 ? 18 * 60 : 20 * 60;
  const fmt = (m) => {
    const h = Math.floor(m / 60);
    const mm = m % 60;
    const ampm = h >= 12 ? "PM" : "AM";
    const h12 = h % 12 === 0 ? 12 : h % 12;
    return `${h12}:${String(mm).padStart(2, "0")} ${ampm}`;
  };
  if (mins >= open && mins < close) {
    return { open: true, kind: "open", time: fmt(close) };
  }
  if (mins < open) {
    return { open: false, kind: "today", time: fmt(open) };
  }
  if (day === 6) {
    return { open: false, kind: "sunday", time: fmt(11 * 60) };
  }
  return { open: false, kind: "tomorrow", time: fmt(10 * 60) };
}
